import { render, staticRenderFns } from "./PageMaintenance.vue?vue&type=template&id=afa735c0&scoped=true"
import script from "./PageMaintenance.vue?vue&type=script&lang=js"
export * from "./PageMaintenance.vue?vue&type=script&lang=js"
import style0 from "./PageMaintenance.vue?vue&type=style&index=0&id=afa735c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa735c0",
  null
  
)

export default component.exports